import { requestAndParse, requestSuccessful } from '../request';

const connectAccount = async (userId: number, teacherId: number) => {
    const route = 'admin/connect-account';
    const payload = {
        userId,
        teacherId,
    };

    const response = await requestAndParse(route, payload);

    const success = requestSuccessful(response);
    const message = response.body?.message as string;

    return { success, message };
};

export default connectAccount;
